export default __webpack_public_path__ + "images/jo-f41fe7d26b69dec06fef1fb61a0e0fff.svg";